// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-badge":"sapcnqr-badge-548a15","sapcnqr-badge--muted":"sapcnqr-badge--muted-2c7fdc"};